<ng-container>
  <form
    nz-form
    [formGroup]="authForm"
    class="auth-form"
    (ngSubmit)="submitForm()"
  >
    <nz-form-item>
      <nz-form-control [nzErrorTip]="emailErrorTpl">
        <nz-input-group [nzPrefix]="emailPrefixTemplate">
          <input
            type="text"
            nz-input
            formControlName="email"
            [placeholder]="'FORM.LABEL.EMAIL' | translate"
          />
        </nz-input-group>
        <ng-template #emailPrefixTemplate>
          <i class="fal fa-envelope"></i>
        </ng-template>
        <ng-template #emailErrorTpl let-control>
          <ng-container *ngIf="control.hasError('maxlength')">
            {{ "FORM.ERR.MAX_CHARS" | translate: { value: 40 } }}
          </ng-container>
          <ng-container *ngIf="control.hasError('email')">
            {{ "FORM.ERR.VALID_EMAIL" | translate }}
          </ng-container>
          <ng-container *ngIf="control.hasError('required')"
            >{{ "FORM.ERR.REQUIRED_EMAIL" | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control [nzErrorTip]="passwordErrorTpl">
        <nz-input-group
          [nzPrefix]="lockPrefixTemplate"
          [nzSuffix]="eyeSuffixTemplate"
        >
          <input
            [type]="passwordVisible ? 'text' : 'password'"
            nz-input
            formControlName="password"
            [placeholder]="'FORM.LABEL.PASSWORD' | translate"
          />
        </nz-input-group>
        <ng-template #eyeSuffixTemplate>
          <i
            class="cursor-pointer fal"
            [ngClass]="passwordVisible ? 'fa-eye-slash' : 'fa-eye'"
            (click)="passwordVisible = !passwordVisible"
          ></i>
        </ng-template>
        <ng-template #lockPrefixTemplate>
          <i class="fal fa-lock"></i>
        </ng-template>
        <ng-template #passwordErrorTpl let-control>
          <ng-container *ngIf="control.hasError('maxlength')">
            {{ "FORM.ERR.MAX_CHARS" | translate: { value: 40 } }}
          </ng-container>
          <ng-container *ngIf="control.hasError('minlength')">
            {{ "FORM.ERR.MIN_CHARS" | translate: { value: 8 } }}
          </ng-container>
          <ng-container *ngIf="control.hasError('required')">
            {{ "FORM.ERR.REQUIRED_PASS" | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control>
        <button
          [nzLoading]="isSubmitting$ | async"
          [disabled]="!authForm.valid"
          nz-button
          class="auth-form-button"
          [nzType]="'primary'"
        >
          {{ "PAGE.AUTH.LOGIN.TITLE" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-container>
